<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/user-accounts" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
          <form @submit.prevent="update" v-if="userRef">
            <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-3">
                    Name: {{userRef.firstName}}&nbsp;{{userRef.lastName}}
                  </div>
                  <div class="col-3">
                    Email: {{userRef.email}}
                  </div>
                  <div class="col-3" v-if="userRef.comments">
                    Current Gift Code: {{userRef.comments}}
                  </div>
                  <div class="col-3" v-if="corps.length">
                    <fg-select
                      v-model="corporationId"
                      label="Select Gift Code"
                      :list="corps"
                      selectedKey="id"
                      v-validate="rules.corporationId"
                      data-vv-name="Corproration"
                      cus-name="Corporation"
                      :has-errors="errors"
                      :is-fields="fields"
                    >
                    </fg-select>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center">
                <button type="submit" :disabled="corporationId === 0" class="btn btn-primary btn-fill btn-block">
                  Update User Association
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'EditUserAccount',
    created (){
      this.userId = this.$route.params.id
      this.fetchCorporations();
      this.fetchUserReference(this.userId)
    },
    data () {
      return {
        userId: 0,
        corporationId: '',
        userRef: null,
        corps: [],
//            playlist: null,
        status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        rules: {
          corporationId : {required: true}
        }
      }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS_WITH_GIFT_CODES')
          .then((res) => {
            res.unshift({name: "Select Gift Code"});
            this.corps = res;
            this.corporationId = res[0].id
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      update () {
        console.log('userId', this.userId)
        console.log('gift code', this.corporationId)
        if (this.corporationId && this.corporationId.length > 0) {
          let updateUserCorporation = () => {
            this.$store.dispatch('UPDATE_USER_CORPORATION', {
              corpGiftId: this.corporationId, userId: this.userId
            })
              .then((res) => {
                console.log("UPDATE_CORPORATION res : ", res);
                this.showPopup('Success!', 'User Corporation is successfully updated', 'success', () => this.$router.push('/admin/user-accounts'))
              })
              .catch(err => {
                this.showPopup('Error!', 'some thing happen wrong', 'error')
                console.log("UPDATE_CORPORATION API error : ", err);
              })
          };
          updateUserCorporation();
        }
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      fetchUserReference (userId) {
        console.log('userId', userId)
        this.$store.dispatch('FETCH_USER_DETAILS', userId)
          .then((res) => {
            this.userRef = res
            console.log('user refernce', this.userRef)
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
    },
    computed: {
      ...mapGetters([ 'corporations', 'selectedPlaylist']),
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    }
  }
</script>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/EditUserAccount.vue